import { useSearchParams, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const OWNER_EMAIL = 'ana@nutrianapereira.pt';

export function HubPage({ id, tabs, defaultTab }) {
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const location = useLocation();
  const visible = tabs.filter(t => (!t.adminOnly || user?.role === 'admin') && (!t.nonAdminOnly || user?.role !== 'admin') && (!t.ownerOnly || (user?.email || '').trim().toLowerCase() === OWNER_EMAIL));
  const wanted = params.get('separador') || (location.hash && visible.find(t => t.hashDefault) ? visible.find(t => t.hashDefault).key : defaultTab);
  const active = visible.find(t => t.key === wanted) || visible[0];
  if (!active) return null;
  const Comp = active.component;
  const select = (key) => { const next = new URLSearchParams(params); next.set('separador', key); next.delete('tab'); setParams(next); };
  return (
    <div data-testid={`hub-${id}`}>
      {visible.length > 1 && (
        <div className="flex gap-2 mb-5 flex-wrap" data-testid={`hub-${id}-tabs`}>
          {visible.map(t => (
            <button key={t.key} onClick={() => select(t.key)} data-testid={`hub-tab-${id}-${t.key}`}
              className={`flex-auto px-3 py-2.5 rounded-xl text-sm font-medium whitespace-nowrap ${active.key === t.key ? 'bg-brand-green text-white' : 'bg-brand-bg text-brand-muted border border-brand-border'}`}>
              {t.label}
            </button>
          ))}
        </div>
      )}
      <Comp key={active.key} />
    </div>
  );
}

export function HubRedirect({ to, separador, filtro }) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  if (separador) params.set('separador', separador);
  if (filtro) params.set('filtro', filtro);
  const qs = params.toString();
  return <Navigate to={`${to}${qs ? `?${qs}` : ''}${location.hash || ''}`} replace />;
}
